module.exports = __webpack_public_path__ + "img/stoneholder-2@2x.2d0dab9.webp";